import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ApiRestService} from "../api-rest.service";
import {Blocco} from "../_Models/blocco";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";
import {ClassicType} from "../../shared/models/ClassicType";
import {Location} from "@angular/common";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-blocchi-edit',
  templateUrl: './blocchi-edit.component.html',
  styleUrls: ['./blocchi-edit.component.css']
})
export class BlocchiEditComponent implements OnInit {
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    enableCheckAll: false,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    textField: "label",
  };
  Blocco: Blocco = new Blocco();
  Sezioni: ClassicType[] = [];
  SezioneSelected: ClassicType[] = [];

  constructor(
    private route: ActivatedRoute,
    private apiRestService: ApiRestService,
    private location: Location,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.refresh(data['id']);
    })
  }

  refresh(id: string) {
    this.apiRestService.SezioniList().subscribe(data=> this.Sezioni = data)
    if(id && !isNaN(parseInt(id)))
      this.apiRestService.GetBlocco({id: parseInt(id)}).subscribe(data => {
        this.Blocco = data;
        this.SezioneSelected = [{id: data.sezione, label: data.sezione}];
      });
    else
      this.Blocco = new Blocco();
  }

  GetBlocco(){
    this.Blocco.sezione = this.SezioneSelected?.length>0 && this.SezioneSelected[0] ? this.SezioneSelected[0].id : null;
  }
  saveClick(close?: boolean) {
   this.GetBlocco()
    if(this.Blocco?.id)
      this.apiRestService.BlocchiUpdate(this.Blocco).subscribe(data => {
        if(close)
          this.location.back();
        else {
          this.toastrService.success("I dati sono stati salvati correttamente");
          this.refresh(this.Blocco?.id.toString())
        }
      })
    else
      this.apiRestService.BlocchiAdd(this.Blocco).subscribe(data=>{
        if(close)
          this.location.back();
        else {
          this.toastrService.success("I dati sono stati salvati correttamente");
          this.refresh(data?.id.toString())
        }
      })
  }
}
